<template>
  <div class="th-page-course-saya">
    <h2 class="th-title">Course Saya</h2>
    <div
      style="height: 50vh"
      class="flex justify-center items-center"
      v-if="!cardCourseDatas.length"
    >
      Belum ada course.
    </div>
    <div v-else class="grid lg:grid-cols-3 gap-4">
      <div v-for="(course, i) in cardCourseDatas" :key="i" class="">
        <router-link
          :to="{ name: 'Detail Course Saya', params: { id: course.key } }"
          @click.native="toDetail"
        >
          <CardCourseProgress :content="course" />
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
const CardCourseProgress = () => import('@/components/Shared/CardCourse/CourseProgress')
export default {
  components: { CardCourseProgress },
  data() {
    return {
      cardCourseDatas: [],
    }
  },
  methods: {
    toDetail() {
      this.$store.commit('SET_STATE', { currentMenu: 'Course Saya' })
    },
    async fetchMyCourses() {
      try {
        const dataMyCourses = await this.$store.dispatch('course/FETCH_MY_COURSE')
        this.cardCourseDatas = dataMyCourses.map(data => {
          // console.log(data)
          return {
            ...data,
            title: data.name,
            key: data._id,
            lessonLogs: data.lessonLogs,
            totalLessons: data.totalLesson,
            lastUpdate: data.lastUpdate,
          }
        })
      } catch (err) {
        console.log(err)
      }
    },
  },
  created() {
    this.fetchMyCourses()
  },
}
</script>

<style lang="scss">
@import "@/components/Kit/utils.scss";
.th-page-course-saya {
  a {
    color: $black !important;
  }
}
</style>
